export default function socialLinks() {
    for (const el of document.querySelectorAll('.nav-threads a, .nav-linkedin a, .nav-mastodon a, .nav-bluesky a')) {
        el.setAttribute('target', '_blank')
    }
}
